import axios, { AxiosResponse } from 'axios';

import { HSCAN_BACKEND_API_URL } from '../../env';

import { Case, GenerateHpacsLinkBody, HpacsLinkResponse } from './case';

export interface RequestActivateQrRequest {
  uri: string;
}
export const requestActivateQr = ({ uri }: RequestActivateQrRequest) => {
  return axios.put<void>(`${HSCAN_BACKEND_API_URL}/qr/${uri}/save`);
};

export const requestQrCase = (sessionId: string) => {
  return axios.get<Case>(`${HSCAN_BACKEND_API_URL}/qr/case`, {
    headers: {
      SESSIONID: sessionId,
    },
  });
};

interface RequestQrDicomImageRequest {
  sessionId: string;
  imageId: string;
}
export const requestQrDicomImage = ({
  imageId,
  sessionId,
}: RequestQrDicomImageRequest) => {
  return axios.get<File>(`${HSCAN_BACKEND_API_URL}/qr/case/image/${imageId}`, {
    responseType: 'blob',
    headers: {
      SESSIONID: sessionId,
    },
  });
};

interface RequestQrDownloadImageRequest {
  sessionId: string;
  sseKey: string;
  caseIds: string[];
}
export const requestQrDownloadImage = ({
  sseKey,
  sessionId,
  caseIds,
}: RequestQrDownloadImageRequest) => {
  return axios.get<File>(
    `${HSCAN_BACKEND_API_URL}/qr/case/dicom/sse/${sseKey}`,
    {
      headers: {
        'Content-Type': 'application/zip',
        SESSIONID: sessionId,
      },
      responseType: 'blob',
      params: { ids: caseIds },
    },
  );
};

/*
@GetMapping(path = "/qr/case/dicom/sse/{sseKey}/event")
public Flux<ServerSentEvent<DicomDownloadEvent>> getSSE(
    @RequestHeader(name = CHALLENGE_HEADER_NAME) String challengeId,
    @PathVariable String sseKey) {
  return qrLinkService.getSSE(challengeId, sseKey);
}
*/

interface GenerateQrHpacsLinkIdRequest {
  body: GenerateHpacsLinkBody;
  sessionId?: string;
}
export const generateQrHpacsLinkId = ({
  body,
  sessionId,
}: GenerateQrHpacsLinkIdRequest) => {
  return axios.post<
    HpacsLinkResponse,
    AxiosResponse<HpacsLinkResponse>,
    GenerateHpacsLinkBody
  >(`${HSCAN_BACKEND_API_URL}/qr/link`, body, {
    headers: {
      SESSIONID: sessionId,
    },
  });
};
